import { Children, cloneElement, useContext, useEffect, useState } from "react";
import { getOauthIndentityProviderUrl } from "app/utils/auth";
import { useLocation, useNavigate } from "react-router-dom";
import { STRATEGY } from "app/constants";
import AppGlobalsContext from "app/AppGlobalsContext";
import { parseQueries } from "app/utils/routerUtils";
import { sendTagOnOauthAccessTokenFailed } from "app/utils/analytics";
import { isAuthenticated } from "app/pages/Auth/authSelectors";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getOAuthToken } from "app/pages/Auth/OAuth/oAuthActionCreators";

// eslint-disable-next-line react/prop-types
const OauthRoute = ({ children, isAuthenticated, getOAuthToken }) => {
	const { strategy } = useContext(AppGlobalsContext);
	const { search = {} } = useLocation();
	const { code } = parseQueries(search);

	const navigate = useNavigate();

	const [showComponent, updateShowComponent] = useState(isAuthenticated);

	useEffect(() => {
		if (!isAuthenticated && strategy === STRATEGY.OAUTH && !code) {
			window.location.replace(getOauthIndentityProviderUrl(window.location.href));
		}
	}, [isAuthenticated, code, strategy]);

	useEffect(() => {
		if (code && strategy === STRATEGY.OAUTH) {
			const redirectUri = window.location.origin + window.location.pathname;

			getOAuthToken({
				code: code,
				redirectUri,
			})
				.then(() => {
					updateShowComponent(true);
				})
				.catch(() => {
					const redirectUri = encodeURIComponent(window.location.href);

					navigate(
						{
							pathname: "/technical-error/sso",
							search: `?redirectUri=${redirectUri}`,
						},
						{ replace: true }
					);
					sendTagOnOauthAccessTokenFailed();
				});
		}
	}, [code, strategy]);

	return (
		showComponent &&
		Children.map(children, child => {
			return cloneElement(child);
		})
	);
};

const mapStateToProps = state => {
	return { isAuthenticated: isAuthenticated(state) };
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			getOAuthToken,
		},
		dispatch
	);
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(OauthRoute);
